import { ProfileType } from 'constants/types';

export function canAccess(auth, menu, action = 'view') {
  if (!menu) return true;
  if (auth?.type !== ProfileType.ADMIN) return true;
  if (auth.isSuperAdmin || !auth.adminRestricted) return true;

  return auth.adminPermissions?.[menu]?.[action] === true;
}

export function filterMenuByPermission(auth, items) {
  return items.reduce((result, item) => {
    if (!canAccess(auth, item.permission)) return result;

    if (Array.isArray(item.subitems)) {
      const subitems = item.subitems.filter((sub) =>
        canAccess(auth, sub.permission)
      );
      if (!subitems.length) return result;
      result.push({ ...item, subitems });
      return result;
    }

    result.push(item);
    return result;
  }, []);
}
